// Add new supported languages here

module.exports = {
  languages: ['en', 'es', 'ca', 'pt', 'de', 'it', 'fr'],
  defaultLanguage: 'en'
};
